import { Route, Routes } from 'react-router-dom';
import { Home } from './pages/Home/Home';
import { Info } from './pages/Info/Info';
import { Room } from './pages/Room/Room';
import { Fullscreen } from './pages/Fullscreen/Fullscreen';
import { useRooms } from './hooks/useRooms';

export const App = (props) => {
  const { cdn } = props;
  const { rooms } = useRooms();

  return (
    <Routes>
      <Route path="/" element={<Home cdn={cdn} />} />
      {rooms[0]
        ? rooms.map((room, i) => {
            return (
              <Route
                path={`/room/${room.label.toLowerCase().replace(/\s/g, '_')}`}
                element={<Room cdn={cdn} room={room} />}
                key={i}
              />
            );
          })
        : null}
      {rooms[0]
        ? rooms.map((room, i) => {
            return (
              <Route
                path={`/fullscreen/${room.label.toLowerCase().replace(/\s/g, '_')}`}
                element={<Fullscreen cdn={cdn} room={room} />}
                key={i}
              />
            );
          })
        : null}
      <Route path="/info" element={<Info cdn={cdn} />} />
    </Routes>
  );
};
